import React, { useMemo } from 'react';
import { Row, Col } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Panel from '@dex/bubl-dash/src/lib/components/Panel/Panel';
import MetaTable from '@dex/bubl-dash/src/lib/components/MetaTable/MetaTable';
import ActivityPanel from '@dex/bubl-dash/src/lib/components/SinglePanels/ActivityPanel';
import { Space } from '@dex/bubl-dash/src/lib/components/Layout/Layout';
import Seperator from '@dex/bubl-dash/src/lib/components/Seperator/Seperator';
import { Line } from '@dex/bubl-dash';

const AppActivitySingleView: React.FC<any> = (props: any) => {

    const { data } = props;

    return useMemo(() => (

        <Row
            gutter={'auto'}
        >

            <Col
                className={'main'}
            >

                <Panel
                    heading={"AppActivity Details"}
                >

                    <MetaTable
                        data={data}
                        columnA={[
                            {
                                label: 'User',
                                key: 'user',
                                format: "ModelLink"
                            },
                            {
                                label: 'Action',
                                key: 'action',
                                format: 'titleCase'
                            },
                            {
                                label: 'Type',
                                key: 'type',
                                format: 'titleCase'
                            }
                        ]}
                        columnB={[
                            {
                                label: 'Model Name',
                                key: 'modelName',
                                format: 'titleCase'
                            },
                            {
                                label: 'Model Id',
                                key: 'modelId',
                                format: 'titleCase'
                            }
                        ]}
                        columnC={[

                        ]}
                    />


                </Panel>

            </Col>

            <Col className={'side'}>

                <ActivityPanel parent={data} />

            </Col>

        </Row>

    ), [data]);

}

export default AppActivitySingleView;
